import React, { useState } from "react";
import { Search } from "lucide-react";

export default function HeaderSearch({ onSearch }: { onSearch?: (q: string) => void }) {
  const [q, setQ] = useState("");
  const [focused, setFocused] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(q);
    }
  };

  return (
    <div className="relative max-w-xl">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
        <Search className="w-4 h-4" />
      </div>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={`
          w-full rounded-xl border bg-white pl-10 pr-3 py-2 text-sm text-slate-900 placeholder-slate-400 shadow-sm
          transition-all duration-300
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#18365E]
          ${focused ? 'border-[#18365E] scale-[1.02]' : 'border-slate-200'}
        `}
        placeholder="Search insights, reports, or analytics…"
        aria-label="Search"
      />
    </div>
  );
}